var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-snackbar',{attrs:{"value":_vm.alert.active,"dismissible":"","color":_vm.alert.type,"timeout":"-1"}},[_vm._v(" "+_vm._s(_vm.alert.message)+" ")]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }